module.exports = __webpack_public_path__ + "img/9788958286165.4374bafc.jpg";